















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Card from '@/stories/utils/card.vue'
import Virtualize from '@/components/virtualize/virtualize.vue'


@Component({
  components: {
    Card,
  }
})
export default class StorybookTreeView extends Vue {
  get rows() {
    return [
      { 
        id:1,
        name:'level 1',
        children:[
          {
            name:'level 123',
            id:2,
          },
          {
            name:'level 123',
            id:3,
          },
        ]
      },

      {
        id:4,
        name:'level 2',
        children:[
          {
            id:5,
            name:'level 223'
          },
          {
            id:6,
            name:'level 223',
            children:[
              {
                id:7,
                name:'level 223'
              },
              {
                id:8,
                name:'level 223'
              },
            ]
          },
        ]
      }
    ]
  }
}
